import React from 'react';
import { Button } from './ui/button';
import { Calendar, Phone, ArrowRight } from 'lucide-react';
import { clinicInfo } from '../mockData';

export const CTABanner = ({ variant = 'default' }) => {
  const handleBookNow = () => {
    window.open(clinicInfo.bookingUrl, '_blank', 'noopener,noreferrer');
  };

  if (variant === 'light') {
    return (
      <section className="py-16 bg-teal-50">
        <div className="container mx-auto px-4">
          <div className="max-w-5xl mx-auto bg-white rounded-3xl shadow-xl p-8 md:p-12 border border-teal-100">
            <div className="flex flex-col md:flex-row items-center justify-between gap-6">
              <div className="text-center md:text-left">
                <h3 className="text-2xl md:text-3xl font-bold text-gray-900 mb-2">
                  Ready for expert podiatry care?
                </h3>
                <p className="text-gray-600 text-lg">
                  Book your appointment today and take the first step towards healthier feet.
                </p>
              </div>
              <div className="flex flex-col sm:flex-row gap-3 flex-shrink-0">
                <Button
                  onClick={handleBookNow}
                  className="bg-teal-600 hover:bg-teal-700 text-white px-8 py-6 text-lg rounded-full transition-all duration-300 hover:shadow-xl hover:scale-105 group"
                >
                  <Calendar className="w-5 h-5 mr-2" />
                  Book Now
                  <ArrowRight className="w-5 h-5 ml-2 group-hover:translate-x-1 transition-transform" />
                </Button>
                <a href={`tel:${clinicInfo.phone}`}>
                  <Button
                    variant="outline"
                    className="border-2 border-teal-600 text-teal-700 hover:bg-teal-50 px-8 py-6 text-lg rounded-full transition-all duration-300 w-full"
                  >
                    <Phone className="w-5 h-5 mr-2" />
                    Call Us
                  </Button>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="py-16 bg-gradient-to-r from-teal-600 to-teal-700 relative overflow-hidden">
      {/* Decorative elements */}
      <div className="absolute top-0 left-0 w-64 h-64 bg-teal-400/20 rounded-full blur-3xl -translate-x-32 -translate-y-32"></div>
      <div className="absolute bottom-0 right-0 w-72 h-72 bg-teal-300/20 rounded-full blur-3xl translate-x-32 translate-y-32"></div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-4xl mx-auto text-center text-white">
          <h3 className="text-3xl md:text-4xl font-bold mb-4">
            Take the first step today
          </h3>
          <p className="text-xl text-teal-100 mb-8 max-w-2xl mx-auto">
            Expert care for every step — book your appointment with our experienced team.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button
              onClick={handleBookNow}
              className="bg-white text-teal-700 hover:bg-teal-50 px-8 py-6 text-lg rounded-full transition-all duration-300 hover:shadow-2xl hover:scale-105 group"
            >
              <Calendar className="w-5 h-5 mr-2" />
              Book Your Appointment
              <ArrowRight className="w-5 h-5 ml-2 group-hover:translate-x-1 transition-transform" />
            </Button>
            <a href={`tel:${clinicInfo.phone}`}>
              <Button
                variant="outline"
                className="bg-transparent border-2 border-white text-white hover:bg-white hover:text-teal-700 px-8 py-6 text-lg rounded-full transition-all duration-300 w-full"
              >
                <Phone className="w-5 h-5 mr-2" />
                {clinicInfo.phone}
              </Button>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};
